import {IconProps, Icon} from '@chakra-ui/react';

export const EarnedBadgesIcon = (props: IconProps) => (
  <Icon width="17px" height="17px" viewBox="0 0 17 17" fill="none" {...props}>
    <path
      d="M7.52527 1.04404C8.1311 0.705896 8.8689 0.705897 9.47473 1.04404L15.3292 4.31165C16.0375 4.70698 16.4369 5.49099 16.3402 6.29637L15.5733 12.6863C15.4842 13.4289 14.9881 14.0597 14.2874 14.3215L9.18061 16.2291C8.71397 16.4034 8.19908 16.3973 7.7367 16.212L3.00477 14.3154C2.3543 14.0547 1.88773 13.4726 1.77492 12.781L0.725861 6.34975C0.590301 5.5187 0.989777 4.69175 1.72504 4.28137L7.52527 1.04404Z"
      fill="url(#paint0_linear_48_722)"
      fillOpacity="0.3"
      stroke="url(#paint1_linear_48_722)"
      strokeWidth="0.5"
    />
    <path
      d="M8.0708 8.24894L9.96779 4.52844L8.24116 4.36801L6.24757 9.27742L8.54974 9.49132L7.37218 13.2787L10.373 8.46284L8.0708 8.24894Z"
      fill="url(#paint2_linear_48_722)"
      stroke="url(#paint3_linear_48_722)"
      strokeWidth="0.5"
    />
    <defs>
      <linearGradient id="paint0_linear_48_722" x1="0.5" y1="8.5" x2="16.5" y2="8.49848" gradientUnits="userSpaceOnUse">
        <stop stopColor="#AA6535" />
        <stop offset="1" stopColor="#FBBF95" />
      </linearGradient>
      <linearGradient id="paint1_linear_48_722" x1="0.5" y1="8.5" x2="16.5" y2="8.49848" gradientUnits="userSpaceOnUse">
        <stop stopColor="#AA6535" />
        <stop offset="1" stopColor="#FBBF95" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_48_722"
        x1="6.29587"
        y1="8.68296"
        x2="10.3285"
        y2="9.01044"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#AA6535" />
        <stop offset="1" stopColor="#FBBF95" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_48_722"
        x1="6.29587"
        y1="8.68296"
        x2="10.3285"
        y2="9.01044"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#AA6535" />
        <stop offset="1" stopColor="#FBBF95" />
      </linearGradient>
    </defs>
  </Icon>
);
